import { post } from './helpers'

export const trackServerSideIdentify = params => {
  post('api/analytics/identify', {
    data: params
  })
}
